<template>
  <div>
    <vs-row class="mb-10">
      <vs-button
        @click="activeCreatePrompt = true"
        class="rounded-full"
        color="primary"
        icon-pack="feather"
        icon="icon-plus-circle"
        type="filled"
        >Добавить сотрудника</vs-button
      >
    </vs-row>

    <vx-card
      title="Фильтры"
      class="p-1 mb-3 passes__filter-card"
      style="background: #e3e6fd"
      collapseAction
    >
      <div class="flex flex-wrap items-center justify-between w-full">
        <div class="header-filter md:w-1/3 md:px-2 w-full mb-2 cursor-pointer">
          <v-select
            :options="countItemsOmPage"
            :clearable="false"
            v-model="countElements"
            style="background-color: #fff"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>

        <div class="header-filter md:w-1/3 md:px-2 w-full mb-2 cursor-pointer">
          <vs-input
            class="w-full"
            placeholder="ФИО или логин"
            v-model="filter.search"
          />
        </div>
        <div class="header-filter md:w-1/3 md:px-2 w-full mb-2 cursor-pointer">
          <v-select
            @input="changeEmployeeRole"
            label="name"
            :options="employeeRoles"
            :reduce="(name) => name.id"
            :clearable="true"
            placeholder="Роль"
            style="background-color: #fff"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>

        <div class="header-filter md:w-1/3 md:px-2 w-full mb-2 cursor-pointer">
          <v-select
            label="name"
            :options="orderingData"
            :reduce="(name) => name.id"
            :clearable="true"
            v-model="filter.ordering"
            placeholder="Дата входа"
            style="background-color: #fff"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>
      </div>
    </vx-card>

    <vx-card title="Список сотрудников" class="p-6">
      <vs-table
        :data="employees"
        :stripe="true"
        :search="false"
        :pagination="false"
        :maxItems="20"
        noDataText="Элементов не найдено"
        id="div-with-loading"
      >
        <template slot="thead">
          <vs-th> # </vs-th>
          <vs-th> Данные </vs-th>
          <vs-th> Роль </vs-th>
          <vs-th> Последний вход </vs-th>
          <vs-th> Действия </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              {{ data[indextr].id }}
            </vs-td>

            <vs-td>
              <p v-if="data[indextr].full_name" class="mb-3">
                ФИО:
                <span class="text-primary">{{ data[indextr].full_name }}</span>
              </p>
              <p class="mb-3">
                Телефон/логин:
                <span class="text-primary">{{ data[indextr].phone }}</span>
              </p>
            </vs-td>

            <vs-td>
              <template v-if="data[indextr].is_staff"> Администратор </template>
              <template v-else-if="data[indextr].is_security">
                Охрана
              </template>
              <template v-else-if="data[indextr].is_cafe_personal">
                Кафе
              </template>
              <template v-else-if="data[indextr].is_market_personal">
                Маркет
              </template>
            </vs-td>

            <vs-td>
              {{
                data[indextr].last_login !== null
                  ? formatDateTime(data[indextr].last_login)
                  : "Не входил"
              }}
            </vs-td>

            <vs-td>
              <vx-tooltip class="inline-block" text="Редактировать сотрудника">
                <vs-button
                  @click="openEdit(data[indextr].id)"
                  color="dark"
                  class="text-dark mr-3"
                  icon-pack="feather"
                  icon="icon-edit"
                  size="large"
                  type="flat"
                ></vs-button>
              </vx-tooltip>
              <vx-tooltip class="inline-block" text="Удалить сотрудника">
                <vs-button
                  @click="deleteEmployee(data[indextr].id)"
                  color="dark"
                  class="text-dark"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  size="large"
                  type="flat"
                ></vs-button>
              </vx-tooltip>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        class="mt-4"
        :total="totalPagePagination"
        v-model="currentPagingationPage"
      ></vs-pagination>
    </vx-card>

    <vs-popup title="Добавить сотрудника" :active.sync="activeCreatePrompt">
      <div class="loading-wrap vs-con-loading__container">
        <vs-input
          class="w-full mb-4"
          v-validate="'required'"
          data-vv-validate-on="blur"
          label="Телефон"
          name="Телефон"
          v-model="newEmployee.phone"
        />
        <span class="text-danger text-sm">{{ errors.first("Телефон") }}</span>

        <vs-input
          class="w-full mb-4"
          v-validate="'required'"
          data-vv-validate-on="blur"
          label="Пароль"
          name="Пароль"
          type="password"
          v-model="newEmployee.password"
        />
        <span class="text-danger text-sm">{{ errors.first("Пароль") }}</span>

        <vs-input
          class="w-full mb-4"
          v-validate="'required'"
          data-vv-validate-on="blur"
          label="ФИО"
          name="ФИО"
          v-model="newEmployee.full_name"
        />
        <span class="text-danger text-sm">{{ errors.first("ФИО") }}</span>

        <ul class="flex justify-center">
          <li class="mr-3">
            <vs-radio
              v-model="newEmployee.type"
              vs-name="userType"
              vs-value="is_staff"
              >Администратор</vs-radio
            >
          </li>
          <li class="mr-3">
            <vs-radio
              v-model="newEmployee.type"
              vs-name="userType"
              vs-value="is_security"
              >Охрана</vs-radio
            >
          </li>
          <li class="mr-3">
            <vs-radio
              v-model="newEmployee.type"
              vs-name="userType"
              vs-value="is_cafe_personal"
              >Кафе</vs-radio
            >
          </li>
          <li>
            <vs-radio
              v-model="newEmployee.type"
              vs-name="userType"
              vs-value="is_market_personal"
              >Маркет</vs-radio
            >
          </li>
        </ul>

        <div class="popup-footer mt-4">
          <vs-button
            @click="createEmployee"
            class="mr-5 vs-con-loading__container"
            ref="loadableButton"
            type="relief"
            vslor="primary"
            >Создать</vs-button
          >
        </div>
      </div>
    </vs-popup>

    <vs-popup title="Обновить сотрудника" :active.sync="activeEditPrompt">
      <div class="loading-wrap vs-con-loading__container">
        <vs-input
          class="w-full mb-4"
          v-validate="'required'"
          data-vv-validate-on="blur"
          label="Телефон"
          name="Телефон"
          v-model="editEmployee.phone"
        />
        <span class="text-danger text-sm">{{ errors.first("Телефон") }}</span>

        <vs-input
          class="w-full mb-4"
          v-validate="'required'"
          data-vv-validate-on="blur"
          label="ФИО"
          name="ФИО"
          v-model="editEmployee.full_name"
        />
        <span class="text-danger text-sm">{{ errors.first("ФИО") }}</span>

        <ul class="flex justify-center">
          <li class="mr-3">
            <vs-radio
              v-model="editEmployee.type"
              vs-name="userType"
              vs-value="is_staff"
              >Администратор</vs-radio
            >
          </li>
          <li class="mr-3">
            <vs-radio
              v-model="editEmployee.type"
              vs-name="userType"
              vs-value="is_security"
              >Охрана</vs-radio
            >
          </li>
          <li class="mr-3">
            <vs-radio
              v-model="editEmployee.type"
              vs-name="userType"
              vs-value="is_cafe_personal"
              >Кафе</vs-radio
            >
          </li>
          <li>
            <vs-radio
              v-model="editEmployee.type"
              vs-name="userType"
              vs-value="is_market_personal"
              >Маркет</vs-radio
            >
          </li>
        </ul>

        <div class="popup-footer mt-4">
          <vs-button
            @click="updateEmployee"
            class="mr-5 vs-con-loading__container"
            ref="loadableButton"
            type="relief"
            vslor="primary"
            >Обновить</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { API_URL, countItemsOmPage } from "@/.env";

export default {
  data: () => ({
    employees: [],
    BASE_URL: API_URL,
    activeCreatePrompt: false,

    newEmployee: {
      phone: "",
      full_name: "",
      password: "",
      type: "",
    },

    editEmployee: {},
    activeEditPrompt: false,
    filter: {
      search: "",
      ordering: "",
    },

    countElements: 20,
    currentPagingationPage: 1,
    totalEmployees: 0,
    totalPagePagination: 1,
    countItemsOmPage,

    employeeRoles: [
      { id: "is_staff", name: "Администратор" },
      { id: "is_security", name: "Охрана" },
      { id: "is_cafe_personal", name: "Сотрудник кафе" },
      { id: "is_market_personal", name: "Сотрудник маркета" },
    ],
    orderingData: [
      { id: "last_login", name: "↑Последний вход" },
      { id: "-last_login", name: "↓Последний вход" },
    ],
  }),
  components: {},
  watch: {
    filter: {
      handler(val) {
        this.filterEmployees();
      },
      deep: true,
    },
    countElements: function () {
      this.currentPagingationPage = 1;
      this.getEmployees();
    },
    currentPagingationPage: function () {
      this.getEmployees();
    },
  },
  computed: {},
  methods: {
    changeEmployeeRole(val) {
      this.employeeRoles.forEach((el) => {
        if (el.id == val) {
          this.filter[val] = true;
        } else {
          delete this.filter[el.id];
        }
      });

      this.filterEmployees();
    },
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    filterEmployees: _.debounce(function () {
      this.currentPagingationPage = 1;
      this.getEmployees();
    }, 1000),
    formatDateTime(date) {
      let now = new Date(date);

      let options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };

      return now.toLocaleString("ru-ru", options);
    },
    createEmployee() {
      let payload = {
        phone: this.newEmployee.phone,
        password: this.newEmployee.password,
        full_name: this.newEmployee.full_name,
        is_staff: this.newEmployee.type == "is_staff" ? true : false,
        is_security: this.newEmployee.type == "is_security" ? true : false,
        is_cafe_personal:
          this.newEmployee.type == "is_cafe_personal" ? true : false,
        is_market_personal:
          this.newEmployee.type == "is_market_personal" ? true : false,
      };

      this.$load(async () => {
        let res = await this.$api.employees.createEmployee(payload);

        if (res.status == 200) {
          this.employees.splice(0, 0, res.data);

          this.notification("Успешно", "Сотрудник создан", "success");

          this.clearNewImployee();
          this.activeCreatePrompt = false;
        }
      });
    },
    clearNewImployee() {
      this.newEmployee = {
        phone: "",
        full_name: "",
        password: "",
        type: "",
      };
    },
    getEmployees() {
      this.$vs.loading();

      this.filter.page =
        this.currentPagingationPage !== 1 ? this.currentPagingationPage : 1;
      this.filter.limit = this.countElements !== 20 ? this.countElements : 20;

      this.$load(async () => {
        let res = (await this.$api.employees.getEmployees(this.filter)).data;

        this.totalEmployees = res.count;
        this.totalPagePagination = Math.ceil(
          this.totalEmployees / this.countElements
        );

        this.employees = res.results;
        this.$vs.loading.close();
      });
    },
    deleteEmployee(idEmployee) {
      let item = this.employees.find((x) => x.id == idEmployee),
        index = this.employees.indexOf(item);

      this.$load(async () => {
        let res = (await this.$api.employees.deleteEmployee(idEmployee)).data;

        if (index !== -1) {
          this.employees.splice(index, 1);
        }

        this.notification("Успешно", "Сотрудник удален", "success");
      });
    },
    openEdit(idEmployee) {
      let employee = this.employees.find((x) => x.id == idEmployee);

      if (employee.is_staff) employee.type = "is_staff";
      else if (employee.is_security) employee.type = "is_security";
      else if (employee.is_cafe_personal) employee.type = "is_cafe_personal";
      else if (employee.is_market_personal)
        employee.type = "is_market_personal";

      this.editEmployee = employee;
      this.activeEditPrompt = true;
    },
    updateEmployee() {
      let payload = {
        phone: this.editEmployee.phone,
        full_name: this.editEmployee.full_name,
        is_staff: this.editEmployee.type == "is_staff" ? true : false,
        is_security: this.editEmployee.type == "is_security" ? true : false,
        is_cafe_personal:
          this.editEmployee.type == "is_cafe_personal" ? true : false,
        is_market_personal:
          this.editEmployee.type == "is_market_personal" ? true : false,
      };

      this.$load(async () => {
        let res = await this.$api.employees.updateEmployee(
          this.editEmployee.id,
          payload
        );

        if (res.status == 200) {
          this.notification("Успешно", "Сотрудник обновлен", "success");

          this.activeEditPrompt = false;
        }
      });
    },
  },
  created() {},
  mounted() {
    this.getEmployees();
  },
};
</script>